import React, { useMemo, useState } from 'react';
import { ICON_NAMES } from '@lexody/design-tokens/icon-map';
import { semantic } from '@lexody/design-tokens';
import Icon from './Icon';
import { OUTLINE_FALLBACK_ICON_NAMES } from './solidIconPaths';

const outlineFallbackSet = new Set(OUTLINE_FALLBACK_ICON_NAMES);

const IconGallery = () => {
  const [query, setQuery] = useState('');
  const [showOutlineOnly, setShowOutlineOnly] = useState(false);

  const icons = useMemo(() => {
    const normalizedQuery = query.trim().toLowerCase();
    return ICON_NAMES.filter((name) => {
      if (showOutlineOnly && !outlineFallbackSet.has(name)) return false;
      if (!normalizedQuery) return true;
      return name.toLowerCase().includes(normalizedQuery);
    }).sort();
  }, [query, showOutlineOnly]);

  const solidCount = ICON_NAMES.length - OUTLINE_FALLBACK_ICON_NAMES.length;

  return (
    <div className="icon-gallery">
      <header className="icon-gallery__header">
        <h1 className="icon-gallery__title">Lexody icons</h1>
        <p className="icon-gallery__subtitle">
          {ICON_NAMES.length} canonical icons · {solidCount} true solid ·{' '}
          {OUTLINE_FALLBACK_ICON_NAMES.length} outline fallback
        </p>
        <div className="icon-gallery__controls">
          <input
            type="search"
            className="icon-gallery__search"
            placeholder="Search icons…"
            value={query}
            onChange={(event) => setQuery(event.target.value)}
            aria-label="Search icons"
          />
          <label className="icon-gallery__filter">
            <input
              type="checkbox"
              checked={showOutlineOnly}
              onChange={(event) => setShowOutlineOnly(event.target.checked)}
            />
            Show outline fallbacks only
          </label>
        </div>
      </header>

      <div className="icon-gallery__grid">
        {icons.map((name) => {
          const isOutlineFallback = outlineFallbackSet.has(name);

          return (
            <div
              key={name}
              className={`icon-gallery__card${isOutlineFallback ? ' icon-gallery__card--outline-fallback' : ''}`}
            >
              <div className="icon-gallery__preview">
                <Icon name={name} size={32} color={semantic.greyscale.text.body} />
              </div>
              <p className="icon-gallery__name">{name}</p>
              {isOutlineFallback && (
                <span className="icon-gallery__badge">outline fallback</span>
              )}
            </div>
          );
        })}
      </div>

      {icons.length === 0 && (
        <p className="icon-gallery__empty">No icons match your search.</p>
      )}
    </div>
  );
};

export default IconGallery;
